// extracted by mini-css-extract-plugin
export default {"body":"Proyecciones_body__iCAdR","content":"Proyecciones_content__o3qUx","menuGroup":"Proyecciones_menuGroup__zh+mW"};